import classNames from 'classnames';
import { useUserType } from 'hooks/useUserType';
import { FC } from 'react';
import type { SolveResultFormat } from 'state/quotes/results/result.model';

import { CompactSolveResult } from './CompactSolveResult';
import { SolveResult } from './SolveResult';
import { XMarginBadge } from './XMarginBadge';

export type PriceColor = 'success' | 'info' | 'warning' | 'danger' | 'secondary';

interface PriceProps {
  className?: string;
  color: PriceColor;

  compactMode?: boolean;
  solveResult: number;
  solveResultFormat?: SolveResultFormat;
  xMargin?: number;
}

export const Price: FC<PriceProps> = ({ solveResult, solveResultFormat, xMargin, color, className, compactMode }) => {
  const userType = useUserType();

  return (
    <div className={classNames('d-flex', className)}>
      <div className="flex-grow-1">
        {compactMode ? (
          <CompactSolveResult value={solveResult} format={solveResultFormat ?? 'Percent'} />
        ) : (
          <SolveResult value={solveResult} format={solveResultFormat ?? 'Percent'} />
        )}
      </div>
      <div className="d-flex flex-column justify-content-end align-self-end">
        {userType === 'internalSale' && xMargin !== undefined && <XMarginBadge value={xMargin} color={color} />}
      </div>
    </div>
  );
};

Price.displayName = 'Price';
